import axios from "axios";

const TestApiAuth = () => {
  const testAuth = () => {
    axios
      .get("https://heroic-app-ncpaf.ampt.app/testing-cookie", {
        withCredentials: true,
      })
      .then((response) => {
        console.log(response);
      });
  };

  return (
    <div>
      <button onClick={testAuth}>Test Auth</button>
    </div>
  );
};

export default TestApiAuth;
